import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
  timeout: 20000,
});

// Fase 6: sessione solo tramite cookie httpOnly (non leggibile dagli script). Rimuove eventuali copie legacy del token.
localStorage.removeItem("csp_token");

// 401 → logout controllato una sola volta (anche con richieste parallele). 403/404/500 non toccano la sessione.
let sessionExpiredHandled = false;
const AUTH_FREE = ["/auth/login", "/auth/me", "/auth/logout"];
api.interceptors.response.use(
  (r) => r,
  (error) => {
    const status = error?.response?.status;
    const url = error?.config?.url || "";
    if (status === 401 && !AUTH_FREE.some((p) => url.includes(p)) && !sessionExpiredHandled) {
      sessionExpiredHandled = true;
      localStorage.removeItem("csp_token");
      window.dispatchEvent(new CustomEvent("csp:session-expired"));
      if (!window.location.pathname.startsWith("/login")) window.location.replace("/login?expired=1");
    }
    return Promise.reject(error);
  }
);

export function formatApiError(detail) {
  if (detail == null) return "Errore imprevisto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}
